import dio, { DioContext, DioType } from './init';

export default {
  clickSmartLockOption: () =>
    dio.track(
      'gfh_guesty_locks_manager_diamond_click',
      DioType.CLICK,
      {},
      DioContext.SMART_LOCKS
    ),
};
